<template>
  <v-row :key="index">
    <v-col class="addons_column">
      
      <v-card class="addons_singleaddon d-flex justify-space-between align-center">

        <div class="d-flex justify-start align-center">
          <div>
            <v-checkbox v-model="addon.checked" @change="deselectIfUnchecked(addon)" :disabled="disableCheck" hide-details />
          </div>
          <div>{{addon.name}}</div>
        </div>

        <div class="d-flex justify-end align-center">
          <template v-if="addon.group">
            <div class="addons_select mr-2">
              <v-select v-model="addon.selected" :items="addon.options" item-text="name" label="Option" @change="checkIfSelected(addon)" :error="addon.selectError" return-object dense outlined hide-details />
            </div>
          </template>

          <!-- CAN ADD THE QUANTITY NUMBER FIELD HERE FOR VOIP HERE -->

          <div class="addons_price">
            <v-text-field :value="addon.group ? addon.selected.price : addon.price | formatCurrency" type="tel" label="Total" readonly dense outlined hide-details />
          </div>
        </div>

      </v-card>
      
    </v-col>
  </v-row>
</template>

<script>
  export default {

    props: {
      index: {
        type: String,
        default: ''
      },

      addon: {
        type: Object,
        default: ()=>({})
      },

      disableCheck: {
        type: Boolean,
        default: false
      },
    },

    watch: {
      addon: {
        deep: true,
        handler(){
          if(this.addon.group && this.addon.checked && !this.addon.selected.id){
            this.addon.selectError = true;
          }else{
            this.addon.selectError = false;
          }
        }
      }
    },

    methods: {
      checkIfSelected(addon){
        addon.checked = addon.selected.id;
      },

      deselectIfUnchecked(addon){
        if(addon.group && !addon.checked){ addon.selected = {}; }
      },
    },
  
  }
</script>

<style lang="scss" scoped>

  ::v-deep {
    .v-input--checkbox {
      margin-top: 0;
      padding-top: 0;
    }
  }

  .addons_column {
    padding: 0 13px;
    margin-bottom: 12px;
  }

  .addons_singleaddon {
    padding: 5px 10px;
  }

  .addons_select {
    width: 200px;
  }

  .addons_price {
    width: 80px;
  }

</style>
